import React from 'react';
import { useAppSelector } from '../../../../store/hooks/StoreHooks';
import TableComponent from '../../../common/TableComponent';
import useJetliftWellSurveyFacade from '../../../../facade/jetlift/jetlift-output/wellSurvey.facade';

interface WellSurveyDataTableProps {
    onRowClick?: (row: any) => void;
    selectedRow?: any;
    selectedRowId?: string | number | null;
    kopOverride?: number;
}

const WellSurveyDataTable: React.FC<WellSurveyDataTableProps> = ({ onRowClick, selectedRow, selectedRowId, kopOverride }) => {
    const { wellSurveyData } = useAppSelector((state) => state?.jetlift?.wellSurvey);
    const { updateKOPOverride } = useJetliftWellSurveyFacade();

    // Check if data has AZI or DLS values - also check for 0 values
    const hasAziData = wellSurveyData?.some((item: any) => item.azi !== null && item.azi !== undefined && item.azi !== '' && !isNaN(item.azi));
    const hasDlsData = wellSurveyData?.some((item: any) => item.dls !== null && item.dls !== undefined && item.dls !== '' && !isNaN(item.dls));

    const surveyColumns = [
        {
            key: 'md',
            title: 'MD',
            dataIndex: 'md',
            width: hasAziData && hasDlsData ? '25%' : hasAziData || hasDlsData ? '32.5%' : '50%',
            render: (value: any) => value?.toFixed(2) || '-'
        },
        {
            key: 'inc',
            title: 'INC',
            dataIndex: 'inc',
            width: hasAziData && hasDlsData ? '25%' : hasAziData || hasDlsData ? '32.5%' : '50%',
            render: (value: any) => value?.toFixed(2) || '-'
        },
        ...(hasAziData ? [{
            key: 'azi',
            title: 'AZI',
            dataIndex: 'azi',
            width: hasDlsData ? '25%' : '35%',
            render: (value: any) => (
                <div className="flex items-center">
                    <div className="flex items-center rounded text-[14px] border py-1 px-2 text-success-400 border-success-400 font-semibold min-w-[50px]">
                        {value?.toFixed(2) || '-'}
                    </div>
                </div>
            )
        }] : []),
        ...(hasDlsData ? [{
            key: 'dls',
            title: 'DLS',
            dataIndex: 'dls',
            width: hasAziData ? '25%' : '35%',
            render: (value: any) => (
                <div className="flex items-center">
                    <div className="flex items-center rounded text-[14px] border py-1 px-2 text-success-400 border-success-400 font-semibold min-w-[50px]">
                        {value?.toFixed(2) || '-'}
                    </div>
                </div>
            )
        }] : [])
    ];

    const handleRowClick = (row: any) => {
        updateKOPOverride(row.md);
        if (onRowClick) {
            onRowClick(row);
        }
    };

    if (!wellSurveyData || wellSurveyData.length === 0) {
        return null;
    }

    return (
        <div className='well-survey'>
            <TableComponent
                name={"wellSurveyList"}
                data={wellSurveyData}
                columns={surveyColumns}
                rowsPerPage={100}
                clickableRows={true}
                onRowClick={handleRowClick}
                kop={kopOverride}
                overFlowClass='max-h-[400px] overflow-auto'
            />
        </div>
    );
};

export default WellSurveyDataTable;